import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitted(true);
      return;
    }
    formData.delete('website_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9lgb8sit35ii3jdl7qg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        form.reset();
      } else {
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setError('提交失败，请稍后再试。');
        } else {
          setError(serverMsg || '提交失败，请稍后再试。');
        }
      }
    } catch {
      setError('网络错误，请稍后再试。');
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2 text-center">
          联系投稿
        </h2>
        <p className="text-sm text-foreground-500 mb-8 text-center">
          有独家爆料？想合作推广？欢迎联系我们
        </p>

        {submitted ? (
          <div className="bg-background-100 rounded-2xl p-10 border border-background-200/70 text-center">
            <span className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-4">
              <i className="ri-check-line text-primary-600 text-2xl"></i>
            </span>
            <h3 className="text-lg font-bold text-foreground-950 font-heading mb-2">提交成功</h3>
            <p className="text-sm text-foreground-500">感谢你的投稿，我们会在24小时内进行审核处理。</p>
            <button
              onClick={() => setSubmitted(false)}
              className="mt-4 px-5 py-2.5 text-sm font-medium text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer"
            >
              继续投稿
            </button>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70"
          >
            {error && (
              <div className="mb-4 p-3 bg-primary-100 text-primary-700 text-sm rounded-lg">
                {error}
              </div>
            )}

            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="contact-honeypot"
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="你的名字"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
              <input
                id="contact-subject"
                name="subject"
                type="text"
                required
                className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-colors"
                placeholder="投稿 / 合作 / 反馈"
              />
            </div>

            <div className="mb-5">
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">内容</label>
              <textarea
                id="contact-message"
                name="message"
                required
                rows={5}
                maxLength={500}
                className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-colors resize-none"
                placeholder="请详细描述你的爆料内容或合作需求（限500字）"
              ></textarea>
              <p className="text-xs text-foreground-400 mt-1">限500字</p>
            </div>

            <button
              type="submit"
              className="w-full px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              提交投稿
            </button>
          </form>
        )}
      </div>
    </section>
  );
}